import styled from 'styled-components';

import { getSectionGradient, media, space, rems } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';
import fonts from '../../ui/fonts';

const Module = styled.div<{ gradient: boolean }>`
  padding: ${space(8)} 0 ${space(8)} 0;
  background: ${({ theme, gradient }) => (gradient ? getSectionGradient(theme) : colors.neutral[800])};

  .ctaContainer {
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;

    a {
      color: ${colors.neutral[100]};

      &:hover {
        color: ${colors.neutral[800]};
        background: ${colors.neutral[200]};
      }
    }
  }

  ${media.min('medium')`
    padding: ${space(8)} 0;

    .ctaContainer {
      padding-top: ${space(8)};
    }
  `}
`;

const Top = styled.div`
  text-align: center;

  .title {
    ${fonts.titleLG};
    margin-bottom: ${space(6)};
    color: ${colors.neutral[100]};
  }

  ${media.min('medium')`
    .title {
      font-size: ${rems(50)} !important;
    }
  `}
`;

const Bottom = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 2px;

  ${media.min('medium')`
    align-items: initial;
    flex-direction: row;
    justify-content: center;
  `}
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2px;
  max-width: ${rems(395)};
  width: 100%;
  flex: 1;
  display: flex;

  &:last-child {
    margin-bottom: ${space(8)};
  }

  .imageZone {
    img {
      width: 100%;
      min-height: 450px;
    }
  }

  .contentZone {
    background: ${colors.neutral[100]};
    padding: ${space(4)} ${space(3)} ${space(10)} ${space(3)};
    position: relative;

    .ctitle {
      a {
        color: ${colors.neutral[900]};
        ${fonts.titleSM};
        text-decoration: none;
      }
    }

    .description {
      ${fonts.bodyMD};
      color: ${colors.neutral[900]};
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 6;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: ${space(2)} 0 0 0;
    }

    .btn {
      text-decoration: none;
      ${fonts.bodySM};
      position: absolute;
      bottom: ${space(4)};
      display: block;
      text-align: left;
      padding: 0;

      color: ${colors.primary[500]};
      justify-content: start;
      border: 0;

      span {
        margin-right: ${space(1)};
      }

      svg {
        height: ${rems(8)};
        width: ${rems(12)};
        path {
          fill: ${colors.primary[500]};
        }
      }
    }

    .extra {
      ${fonts.bodyXSM};
      color: ${colors.neutral[800]};
      padding-top: ${space(2)};
    }
  }

  ${media.min('medium')`
    &:last-child {
      margin-bottom: 2px;
    }

    .contentZone {
      flex: 1;

      .ctitle {
        a {
          ${fonts.bodyLG};
        }
      }
      .description {
        ${fonts.bodySM};
        -webkit-line-clamp: 3;
      }
    }
  `}
`;

export { Module, Top, Bottom, Card };
